import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import {
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledMedia,
} from '@pkg/primitives';

import {
    textAreaAttachmentTransition,
    TextAreaAttachmentVariant,
    textAreaAttachmentVariants,
} from '../../ProfileHeader.motion';

import { tokens } from './EditIcon.tokens';

interface StyledEditIconProps {
    $subdued?: boolean;
}

export const StyledEditIcon = styled(motion.div).attrs({
    variants: textAreaAttachmentVariants,
    initial: TextAreaAttachmentVariant.Hidden,
    animate: TextAreaAttachmentVariant.Show,
    exit: TextAreaAttachmentVariant.Hidden,
    transition: textAreaAttachmentTransition,
})<StyledEditIconProps>`
    ${styledMedia.iconWrapper};
    ${styledInteraction.interactionDisable};

    position: absolute;
    top: 50%;
    right: ${tokens.size * -1}px;
    margin-top: -${tokens.size / 2}px;
    width: ${tokens.size}px;
    height: ${tokens.size}px;
    transition: color ${duration.normal}ms ${easing.cubic};

    ${({ $subdued }) =>
        $subdued &&
        css`
            color: rgb(255, 255, 255, 0.4);
        `};
`;
